export default {
  path: '/sims/sim-cards',
  name: 'Sims',
  component: () => import(/* webpackChunkName: "base" */ '../views/SimsView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
